import React, { FC } from 'react'
import { NavLink } from 'react-router-dom'

import { Badge } from '../../../../components'
import ListGroupItem from '../../../../components/@list/ListGroupItem/ListGroupItem'
import { LeaveOfAbsence } from '../../../../entities/LeaveOfAbsences/LeaveOfAbsences'
import { getLeaveOfAbsencesDateLabel } from '../../../../entities/LeaveOfAbsences/LeaveOfAbsencesHelpers'
import trans from '../../../../helpers/trans'
import { CardColor } from '../../../../types/cardColor'
import { leaveOfAbsenceStatus, LeaveOfAbsenceStatusTypes } from '../../../../types/LeaveOfAbsenceStatusTypes'

import './LeaveOfAbsenceListItem.scss'

interface LeaveOfAbsenceListItemProps {
    leaveOfAbsence: LeaveOfAbsence;
    className?: string;
}

const LeaveOfAbsenceListItem: FC<LeaveOfAbsenceListItemProps> = ({ leaveOfAbsence, className }) => {
    const status = leaveOfAbsence.status as LeaveOfAbsenceStatusTypes
    const { label, color } = leaveOfAbsenceStatus[status]

    return (
        <ListGroupItem
            className={`leave-of-absence-list-item ${className}`}
        >
            <NavLink
                to={`/${trans('nav.absences.link')}/${leaveOfAbsence.id}`}
                className="leave-of-absence-list-item__link"
            />

            <div className="leave-of-absence-list-item__wrapper">
                <p className="leave-of-absence-list-item__title">{leaveOfAbsence.reason}</p>
                <p className="leave-of-absence-list-item__date-label">{getLeaveOfAbsencesDateLabel(leaveOfAbsence.period.start, leaveOfAbsence.period.end)}</p>
            </div>

            <div className="leave-of-absence-list-item__badges">
                {leaveOfAbsence.hasPendingChangeset && (
                    <Badge color={CardColor.orange} className="leave-of-absence-list-item__badge">
                        {trans('containers.leaveOfAbsenceDetailContainer.pendingChange')}
                    </Badge>
                )}
                <Badge color={color} className="leave-of-absence-list-item__badge">
                    {label}
                </Badge>
            </div>
        </ListGroupItem>
    )
}

export default LeaveOfAbsenceListItem
